const UPLOAD_PATH = /^(https?:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(.+)$/;
const HAS_TRANSFORMATION = /^(?:[a-z]{1,3}_[^/]+)\//;

/**
 * Renvoie une version optimisée d'une image Cloudinary.
 * Les images venant d'ailleurs et les URL déjà transformées restent intactes.
 */
export function cldImg(url, width) {
  if (typeof url !== "string") return url;

  const match = url.match(UPLOAD_PATH);
  if (!match || HAS_TRANSFORMATION.test(match[2])) return url;

  const size = width ? `,c_limit,w_${width}` : "";
  return `${match[1]}f_auto,q_auto${size}/${match[2]}`;
}
